import React, { useState } from "react";

const UpdateJobStatusModal = ({ show, onClose, jobCard, onUpdate }) => {
    const [newStatus, setNewStatus] = useState(jobCard?.status || "PENDING");

    const handleUpdate = () => {
        onUpdate(jobCard.id, newStatus);
        onClose();
    };

    return (
        <div
            className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 transition-opacity ${show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg shadow-lg p-6 w-96"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-blue-600">Update Job Card Status</h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-red-500"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11.3 10.7a1 1 0 0 0 0-1.4L8.4 8l2.9-2.9a1 1 0 1 0-1.4-1.4L7 6.6 4.1 3.7a1 1 0 1 0-1.4 1.4L6.6 8l-2.9 2.9a1 1 0 0 0 0 1.4 1 1 0 0 0 1.4 0L8 9.4l2.9 2.9a1 1 0 0 0 1.4 0z"/>
                        </svg>
                    </button>
                </div>
                <div className="mt-4">
                    <label className="block text-gray-700 font-semibold">Status</label>
                    <select
                        className="w-full mt-2 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                        value={newStatus}
                        onChange={(e) => setNewStatus(e.target.value)}
                    >
                        <option value="PENDING">Pending</option>
                        <option value="IN_PROGRESS">In Progress</option>
                        <option value="COMPLETED">Completed</option>
                        <option value="CANCELLED">Cancelled</option>
                    </select>
                </div>
                <div className="mt-6 flex justify-end space-x-4">
                    <button
                        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-700 focus:outline-none"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 focus:outline-none"
                        onClick={handleUpdate}
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpdateJobStatusModal;
